import { render, staticRenderFns } from "./events-school.vue?vue&type=template&id=ea1e3dea"
import script from "./events-school.vue?vue&type=script&lang=js"
export * from "./events-school.vue?vue&type=script&lang=js"
import style0 from "./events-school.vue?vue&type=style&index=0&id=ea1e3dea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports